<template>
  <div class="base-button">
    <Button
      :type="info.form.formType"
      :size="size"
      :icon="info.form.icon">
      {{info.form.text}}
    </Button>
  </div>
</template>

<script>
import { baseComponentMixins } from '../mixins'

export default {
  name: 'BaseButton',
  mixins: [ baseComponentMixins ],
}
</script>
<style lang="scss" scoped>
.base-button {
  min-height: 58px;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 6px;
  &:hover{
    background: #f6f7ff;
  }
}
</style>
